import { render, staticRenderFns } from "./ServiceAccountSummary.vue?vue&type=template&id=3803fc1a&scoped=true&"
import script from "./ServiceAccountSummary.vue?vue&type=script&lang=js&"
export * from "./ServiceAccountSummary.vue?vue&type=script&lang=js&"
import style0 from "./ServiceAccountSummary.vue?vue&type=style&index=0&id=3803fc1a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3803fc1a",
  null
  
)

export default component.exports